// extracted by mini-css-extract-plugin
export default {"colorBlue":"#0075b6","colorWhite":"#fafafa","colorWhiteTransparent":"rgba(255,255,255,.7254901961)","colorRed":"#ff4848"};